import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineThickness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLineThickness"><Path d="M4.62109 5.75L19.3811 5.75" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round"/><Path d="M5.62109 17.25L18.3811 17.25" stroke="currentColor" strokeWidth="3.25" strokeLinecap="round"/><Path d="M5.12109 11L18.8811 11" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round"/></CentralIconBase>;
});

export default IconLineThickness;
